import { useMemo } from "react";

import Badge from "@/components/atoms/Badge";

const getStatusBadgeColor = (status: string) => {
  switch (status) {
    case "active":
      return "success";
    case "liquidation":
      return "warning";
    default:
      return "natural";
  }
};

type Props = {
  status: string | null | undefined;
};

const StatusBadge = ({ status }: Props) => {
  if (!status) return null;

  const color = useMemo(() => getStatusBadgeColor(status), [status]);

  return <Badge size={"sm"} color={color} label={status} />;
};

export default StatusBadge;
